import { http } from '../../../utils';
const controller = 'service-desk/object-groups';
export const getObjGroups = async (searchCondition, parentId, objectTypeId, businessProcessId, status) => {
    return await http.get(`${controller}/get-all`, {
        params: {
            searchCondition,
            parentId,
            objectTypeId,
            businessProcessId,
            status
        }
    });
};
export const getObjGroup = async (id) => {
    return http.get(`${controller}/${id}`);
};
export const addObjGroup = async (ObjGroup) => {
    return http.post(controller, ObjGroup);
};
export const updateObjGroup = async (id, ObjGroup) => {
    return await http.put(`${controller}/${id}`, ObjGroup);
};
export const deleteObjGroup = async (id) => {
    return await http.delete(`${controller}/${id}`);
};
export const getObjGroupsDropdown = async (objectTypeId) => {
    return await http.get(`${controller}/dropdown`, {
        params: {
            objectTypeId: objectTypeId
        }
    });
};
